import { Button, Flex } from '@chakra-ui/react';
import React from 'react';

import {
  SORT_ORDER_UPDATE_DATE_DESC,
  SORT_ORDER_SESSION_COUNT_DESC,
  SORT_ORDER_LIKE_COUNT_DESC,
  SortOrder,
} from '../common/libs/sortOrder';

const sortButtonItems: {
  label: string;
  value: SortOrder;
}[] = [
  {
    label: '新着順',
    value: SORT_ORDER_UPDATE_DATE_DESC,
  },
  {
    label: '保存数順',
    value: SORT_ORDER_LIKE_COUNT_DESC,
  },
  {
    label: '閲覧数順',
    value: SORT_ORDER_SESSION_COUNT_DESC,
  },
];

export default function SlideSortButtons({
  onClick,
  current,
}: {
  onClick: (value: SortOrder) => void;
  current: SortOrder;
}) {
  const isCurrent = (value: SortOrder) => current === value;
  return (
    <Flex gap={2}>
      {sortButtonItems.map(({ label, value }) => (
        <Button
          key={value}
          onClick={() => onClick(value)}
          color={isCurrent(value) ? 'primaryDark' : 'textSecondary'}
          bgColor={isCurrent(value) ? 'primaryLight' : 'backgroundMedium'}
          fontSize="sm"
          rounded="full"
        >
          {label}
        </Button>
      ))}
    </Flex>
  );
}
